var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeoIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52021 10.4169C4.25333 10.7499 3.74667 10.7499 3.47979 10.4169C1.16435 7.52792 0 5.43208 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 5.43208 6.83565 7.52792 4.52021 10.4169ZM6.66667 4C6.66667 2.52724 5.47276 1.33333 4 1.33333C2.52724 1.33333 1.33333 2.52724 1.33333 4C1.33333 4.93551 2.21884 6.60902 4 8.9214C5.78116 6.60902 6.66667 4.93551 6.66667 4ZM4 5.33333C3.26362 5.33333 2.66667 4.73638 2.66667 4C2.66667 3.26362 3.26362 2.66667 4 2.66667C4.73638 2.66667 5.33333 3.26362 5.33333 4C5.33333 4.73638 4.73638 5.33333 4 5.33333Z",
    fill: "#A653F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoIco);
export default __webpack_public_path__ + "static/media/geoIco.a95820730932cd3c4eafed0e1d5914bc.svg";
export { ForwardRef as ReactComponent };